import type {
  UseContentSwitcherOverflowResult,
  AccumulatedOverflowObject,
} from '../hooks/use-handle-content-switcher.types';

export const handleOverflowOfButtons = (
  buttonWidths: number[],
  containerWidth: number
): UseContentSwitcherOverflowResult => {
  const totalWidth = buttonWidths.reduce((sum, width) => sum + width, 0);

  // If all buttons fit, show them all
  if (totalWidth <= containerWidth) {
    return {
      visibleButtons: buttonWidths.map((_, index) => index),
      overflowedButtons: [],
    };
  }

  // Find how many buttons fit in the available width
  const { visibleButtons, overflowedButtons } = buttonWidths.reduce(
    (acc: AccumulatedOverflowObject, width, index) => {
      if (acc.overflowing || acc.currentWidth + width > containerWidth) {
        return {
          ...acc,
          overflowing: true,
          overflowedButtons: [...acc.overflowedButtons, index],
        };
      }

      return {
        ...acc,
        currentWidth: acc.currentWidth + width,
        visibleButtons: [...acc.visibleButtons, index],
      };
    },
    {
      currentWidth: 0,
      visibleButtons: [],
      overflowedButtons: [],
      overflowing: false,
    }
  );

  // Return one array of visible button indeces, and another of overflowed button indices
  return { visibleButtons, overflowedButtons };
};
